import React from "react"
import { Link } from "react-router-dom"
import { HashLink } from "react-router-hash-link"

const Footer = () => {
  return (
    <footer>
      <div className="row extra-links">
        <div className="column col-one">
          <div className="col-one-container">
            <h3>Quick Links</h3>
            <nav>
              <ul>
                <li>
                  <HashLink to="/#about">About Us</HashLink>
                </li>
                <li>
                  <HashLink to="/#services">Our Services</HashLink>
                </li>
                <li>
                  <Link to="/beats">Beats</Link>
                </li>
                <li>
                  <Link to="/releases">Releases</Link>
                </li>
                {/* <li>
                  <Link to="/sing-thursday">Sing Thursday</Link>
                </li> */}
                {/* <li>
                  <Link to="/team">Team</Link>
                </li> */}
                {/* <li>
                  <Link to="/contact-us">Contact Us</Link>
                </li> */}
              </ul>
            </nav>
          </div>
        </div>
        <div className="column col-two">
          <div className="col-two-container">
            <h3>Follow Us On</h3>
            <nav>
              <ul>
                <li>
                  <a href="http://instagram.com">Instagram</a>
                </li>
                <li>
                  <a href="http://facebook.com">Facebook</a>
                </li>
                <li>
                  <a href="http://youtube.com">YouTube</a>
                </li>
                <li>
                  <a href="http://wa.me">WhatsApp</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div className="column col-three">
          <div className="col-three-container">
            <h3>Get In Touch</h3>
            <h2>
              <span>SOund Zone</span> PNS
            </h2>
            <h4>kimara, Dar Es Salaam - Tanzania</h4>
            <ul>
              <li>
                <a href="#">+255 655 392 445</a>
              </li>
              <li>
                <a href="#">+255 655 392 445</a>
              </li>
              <li>
                <a href="#">+255 655 392 445</a>
              </li>
              <li>
                <a href="#">sozthegovt@gmail.com</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="row copyright">
        <div className="container">
          <p>
            &copy; Copyright 2020 - SOZ the GOVERNMENT, Designed and developed
            by{" "}
            <a href="http://bm-dev.netlify.app" className="dev">
              Benedict Steven
            </a>
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
